// ConfirmModal.jsx
import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import "./clinicWeekly.css";

export default function ConfirmModal({ open, title, message, onOk, onCancel }) {
  useEffect(() => {
    if (!open) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, [open]);

  if (!open) return null;

  const content = (
    <div className="modal-backdrop modal-zfix" onClick={onCancel}>
      <div className="modal" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{title || "Xác nhận"}</h3>
          <button className="icon-btn" onClick={onCancel}>×</button>
        </div>
        <div style={{whiteSpace:"pre-line"}}>{message}</div>
        <div className="modal-actions">
          <button className="btn save" onClick={onOk}>OK</button>
          <button className="btn ghost" onClick={onCancel}>Hủy</button>
        </div>
      </div>
    </div>
  );

  return createPortal(content, document.body);
}
